import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import ButtonSecondary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import TabSet from "../../../../../hiberUiKit/src/molecules/TabSet/TabSet";
import TabSetContent from "../../../../../hiberUiKit/src/molecules/TabSet/TabSetContent";
import Tab from "../../../../../hiberUiKit/src/atoms/Tab/Tab";
import Address from "../../../../../model/address/Address";
import {none, option, Option} from "ts-option";
import PartnerBrand from "../../../../../model/partnerBrand/PartnerBrand";
import PartnerBrandForm from "../../../../partnerBrand/PartnerBrandForm";
import Site from "../../../../../model/site/Site";
import PartnerBrandPoints from "../../../../../model/partnerBrand/PartnerBrandPoints";
import PartnerBrandRewardsDataForm from "../../../../partnerBrand/PartnerBrandRewardsDataForm";
import {FormField} from "../../../../../validation/FormField";
import PartnerBrandRewardsData from "../../../../../model/partnerBrand/PartnerBrandRewardsData";
import PartnerBrandRewardsDataFormBody from "../../PartnerBrandRewardsDataFormBody";
import PartnerBrandUsersTable from "../../PartnerBrandUsersTable";
import {RouteComponentProps, RouteProps, withRouter} from "react-router";
import {Action, Location} from "history";
import UnsavedChangesModal from "../../sections/UnsavedChangesModal";
import {Link} from "react-router-dom";
import IconWrapper from "../../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {Icon} from "../../../../../hiberUiKit/src/atoms/Icon/Icon";
import Routes from "../../../../../navigation/route/Route";
import User from "../../../../../model/user/User";
import PartnerBrandBankData from "../../../../../model/partnerBrand/PartnerBrandBankData";
import PartnerBrandBankDataForm from "../../../../partnerBrand/PartnerBrandBankDataForm";
import PartnerBrandBankDataFormBody from "../../PartnerBrandBankDataFormBody";
import CustomFieldValue from "../../../../../model/job/CustomFieldValue";
import CustomField from "../../../../../model/customField/CustomField";
import PartnerBrandCustomFieldsValues from "../../PartnerBrandCustomFieldsValues";
import PartnerBrandJobTypesConfigModal from "../../modal/PartnerBrandJobTypesConfigModal";
import {api} from "../../../../../api/api";
import Toast from "../../../../helper/Toast";
import TextUtils from "../../../../../utils/TextUtils";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import {getLoggedUser} from "../../../../../store/view/user";
import ImportPartnerBrandCustomersAndLeadsModal from "../../upload/ImportPartnerBrandCustomersAndLeadsModal";
import PartnerBrandBoostersModal from "../../booster/PartnerBrandBoostersModal";
import EditQuoteEmailTemplatesModal from "../../quoteEmailTemplate/EditQuoteEmailTemplatesModal";
import {DealerPriceMatrixState} from "../../../../brand/dto/DealerPriceMatrixState";
import UploadPartnerBrandVehiclesModal from "../../modal/UploadPartnerBrandVehiclesModal";
import PartnerBrandCompanySection from "../../sections/PartnerBrandCompanySection";
import PartnerBrandPayoutsSection from "../../sections/PartnerBrandPayoutsSection";
import PartnerBrandFeaturesSection from "../../sections/PartnerBrandFeaturesSection";
import PartnerBrandLegacySection from "../../sections/PartnerBrandLegacySection";
import PartnerBrandActionsMenu, {PartnerBrandAction} from "../../sections/PartnerBrandActionsMenu";
import PartnerBrandSaveBar from "../../sections/PartnerBrandSaveBar";
import BaseFormController from "../../../../../validation/BaseFormController";
import {
	fieldsWithErrors,
	PARTNER_BRAND_TAB_LABELS,
	PARTNER_BRAND_TABS,
	PartnerBrandTab,
	tabOfField
} from "../../sections/PartnerBrandSections";
import "../../sections/partnerBrandPage.scss";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {PartnerBrand} new brand object.
	 * @param {Option<Address>} selected address for brand.
	 */
	onSubmit: (partnerBrand: PartnerBrand,
		address: Option<Address>,
		rewardsData: Option<PartnerBrandRewardsData>,
		bankData: Option<PartnerBrandBankData>) => void;
	/**
	 * Drops the unsaved changes, staying on the page.
	 */
	onDiscard: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * On add file
	 */
	onAddFile: (file: File) => any
	/**
	 * On remove file
	 */
	onRemoveFile: () => any
	/**
	 * Partner brand.
	 */
	partnerBrand: PartnerBrand
	/**
	 * Address to prepopulate address field.
	 */
	address: Option<Site>
	/**
	 * On add points
	 * @param {PartnerBrandPoints} point
	 */
	onAddPoints: (point: PartnerBrandPoints) => void
	/**
	 * Newly added points
	 */
	points: PartnerBrandPoints[]
	/**
	 * Partner brand related rewards data.
	 */
	rewardsData: Option<PartnerBrandRewardsData>;
	/**
	 * Partner brand bank data.
	 */
	bankData: Option<PartnerBrandBankData>;
	/**
	 * Partner Brand custom fields list.
	 */
	customFields: Option<CustomField[]>;
	/**
	 * Partner brand custom fields values
	 */
	customFieldsValues: Option<CustomFieldValue[]>;
	/**
	 * Update custom field values action.
	 * @param {CustomFieldValue[]} updatedCustomFieldsValues
	 */
	updateCustomFieldsValues: (updatedCustomFieldsValues: CustomFieldValue[]) => void;
}

interface FormViewState {
	/**
	 * Additional form to handle reward related fields.
	 */
	rewardsDataForm: Option<PartnerBrandRewardsDataForm>;
	/**
	 * Additional form to handle bank data fields.
	 */
	bankDataForm: Option<PartnerBrandBankDataForm>;
}

interface State {
	/**
	 * Job type modal indicator
	 */
	showJobTypeModal: boolean
	/**
	 * Download documents indicator
	 */
	isDownloadingDocuments: boolean
	/**
	 * Indicates if import modal is visible.
	 */
	importCustomersAndLeadModalVisible: boolean
	/**
	 * Boosters modal indicator
	 */
	showBoostersModal: boolean
	/**
	 * Vehicles import modal indicator
	 */
	showVehiclesImportModal: boolean
	/**
	 * Quote email templates modal indicator
	 */
	showQuoteEmailTemplatesModal: boolean
}

interface DirtyState {
	/**
	 * Indicates if a logo was added or removed. The file lives outside the form, so it cannot be compared.
	 */
	logoChanged: boolean
	/**
	 * Navigation away from the page stopped while the user decides whether to lose the unsaved changes.
	 */
	pendingLeave: {location: Location, action: Action} | null
}

type IState = BaseFormViewState<PartnerBrandForm> & FormViewState & State & DirtyState;

type Props = RouteComponentProps<RouteProps> & IComponentProps;

const LEAVE_WITH_UNSAVED_CHANGES = "You have unsaved changes. Leave the page and lose them?";

class UpdatePartnerBrandFormView extends BaseFormView<PartnerBrandForm, Props, IState> {
	/**
	 * If true, the quote e-mail templates action is offered.
	 */
	quoteEmailTemplatesAvailable: boolean = getLoggedUser().map(u => u.hasPartnerQuoteEmailTemplatePerm()).getOrElse(false);

	constructor(props: Props) {
		super(props);
		this.state = {
			form: PartnerBrandForm.createFromPartnerBrand(this.props.partnerBrand, props.address.map(a => a.data.address)),
			rewardsDataForm: this.props.rewardsData.map(rd => PartnerBrandRewardsDataForm.createFromPartnerBrandRewardsData(rd)),
			bankDataForm: this.props.bankData.map(bd => PartnerBrandBankDataForm.createFromPartnerBrandBankData(bd)),
			isFormDirty: false,
			shouldValidate: false,
			showJobTypeModal: false,
			isDownloadingDocuments: false,
			importCustomersAndLeadModalVisible: false,
			showBoostersModal: false,
			showVehiclesImportModal: false,
			showQuoteEmailTemplatesModal: false,
			logoChanged: false,
			pendingLeave: null
		};
		this.initialForm = this.state.form;
		this.initialBankDataForm = this.state.bankDataForm;
		this.initialRewardsDataForm = this.state.rewardsDataForm;
		this.initialCustomFieldsValues = this.props.customFieldsValues.map(values => JSON.stringify(values));
		this.onDealerPriceMatrixChange = this.onDealerPriceMatrixChange.bind(this);
	}

	/**
	 * Tab panels, to find the first field with an error on a tab.
	 */
	panels: {[tab: string]: HTMLDivElement} = {};

	/**
	 * The card holding the tabs, which the save bar lines up with.
	 */
	tabsCard: HTMLDivElement | null = null;

	/**
	 * Lifts the hold on navigation away from the page.
	 */
	unblock: (() => void) | null = null;

	/**
	 * The page as loaded. What differs from it is unsaved, so typing a value back to what it was leaves nothing unsaved.
	 */
	initialForm: PartnerBrandForm;
	initialBankDataForm: Option<PartnerBrandBankDataForm>;
	initialRewardsDataForm: Option<PartnerBrandRewardsDataForm>;
	initialCustomFieldsValues: Option<string>;

	onDealerPriceMatrixChange(dealerPriceMatrix: DealerPriceMatrixState) {
		this.setState((prevState: IState) => ({form: prevState.form.copy({dealerPriceMatrix})}));
	}

	onAddFile = (file: File) => {
		this.props.onAddFile(file);
		this.setState({logoChanged: true});
	}

	onRemoveFile = () => {
		this.props.onRemoveFile();
		this.setState({logoChanged: true});
	}

	/**
	 * Tabs holding changes not saved yet, in page order. The page, its tabs, the save bar and the Actions menu
	 * all read this one answer.
	 */
	getDirtyTabs(): PartnerBrandTab[] {
		const dirty: {[tab: string]: boolean} = {};
		this.state.form.changedFieldKeys(this.initialForm).forEach(key => dirty[tabOfField(key)] = true);
		if (JSON.stringify(this.state.form.dealerPriceMatrix) !== JSON.stringify(this.initialForm.dealerPriceMatrix)) {
			dirty[PartnerBrandTab.Payouts] = true;
		}
		if (this.state.logoChanged) {
			dirty[PartnerBrandTab.Company] = true;
		}
		const customFieldsValues = this.props.customFieldsValues.map(values => JSON.stringify(values));
		if (this.initialCustomFieldsValues.isDefined && customFieldsValues.orNull !== this.initialCustomFieldsValues.orNull) {
			dirty[PartnerBrandTab.Company] = true;
		}
		const changedSince = <F extends BaseFormController<F>>(form: Option<F>, initial: Option<F>) =>
			form.exists(f => initial.exists(i => f.changedFieldKeys(i).length > 0));
		if (changedSince(this.state.bankDataForm, this.initialBankDataForm)
			|| changedSince(this.state.rewardsDataForm, this.initialRewardsDataForm)
			|| this.props.points.length > 0) {
			dirty[PartnerBrandTab.Legacy] = true;
		}
		return PARTNER_BRAND_TABS.filter(tab => dirty[tab]);
	}

	/**
	 * Number of fields with an error on each tab that has any, in page order. Counted from the forms rather than
	 * the page, so that hidden tabs count too.
	 */
	getErrorTabs(): Array<{tab: PartnerBrandTab, count: number}> {
		const counts: {[tab: string]: number} = {};
		const add = (tab: PartnerBrandTab, count: number = 1) => counts[tab] = (counts[tab] || 0) + count;
		fieldsWithErrors(this.state.form).forEach(key => add(tabOfField(key)));
		if (this.state.form.getDealerPriceMatrixError()) {
			add(PartnerBrandTab.Payouts);
		}
		if (this.state.form.getCreditValueCapError() && this.state.form.creditValueCapMode.firstError().isEmpty) {
			add(PartnerBrandTab.Payouts);
		}
		this.state.bankDataForm.forEach(bankForm => add(PartnerBrandTab.Legacy, fieldsWithErrors(bankForm).length));
		this.state.rewardsDataForm.forEach(rewardsForm => add(PartnerBrandTab.Legacy, fieldsWithErrors(rewardsForm).length));
		return PARTNER_BRAND_TABS.filter(tab => counts[tab] > 0).map(tab => ({tab, count: counts[tab]}));
	}

	/**
	 * Opens the tab and puts the cursor in its first field with an error.
	 */
	revealFirstError = (tab: PartnerBrandTab) => {
		this.selectTab(tab);
		// After the tab shows: a hidden field can be neither scrolled to nor focused.
		setTimeout(() => {
			const error = this.panels[tab] && this.panels[tab].querySelector(".m-form-group_error");
			const group = error && error.closest(".m-form-group");
			if (!group) {
				return;
			}
			group.scrollIntoView({block: "center"});
			const input = group.querySelector("input:not([type=hidden]):not([disabled]), textarea, select, button") as HTMLElement;
			if (input) {
				input.focus({preventScroll: true});
			}
		});
	}

	componentDidMount() {
		window.addEventListener("beforeunload", this.warnBeforeUnload);
		this.unblock = this.props.history.block(this.onNavigation as any);
		const tabRow = this.getTabRow();
		if (tabRow) {
			tabRow.addEventListener("scroll", this.markTabRowEnd);
		}
		this.revealSelectedTab();
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.location.search !== this.props.location.search) {
			this.revealSelectedTab();
		}
	}

	componentWillUnmount() {
		window.removeEventListener("beforeunload", this.warnBeforeUnload);
		const tabRow = this.getTabRow();
		if (tabRow) {
			tabRow.removeEventListener("scroll", this.markTabRowEnd);
		}
		this.releaseNavigation();
	}

	getTabRow(): HTMLElement | null {
		return this.tabsCard && this.tabsCard.querySelector(".m-tab-set");
	}

	/**
	 * On a phone the tabs do not all fit: the row scrolls so that the selected one is in sight, rather than
	 * under the fade at the row's edge.
	 */
	revealSelectedTab() {
		const tabRow = this.getTabRow();
		const selected = tabRow && tabRow.querySelector(".a-tab.is-active") as HTMLElement;
		if (tabRow && selected && tabRow.scrollWidth > tabRow.clientWidth) {
			tabRow.scrollLeft = Math.max(0, selected.offsetLeft + selected.offsetWidth - tabRow.clientWidth);
		}
		this.markTabRowEnd();
	}

	/**
	 * The fade hints at more tabs to the right, so it goes once the row is scrolled to its end.
	 */
	markTabRowEnd = () => {
		const tabRow = this.getTabRow();
		if (tabRow && this.tabsCard) {
			const atEnd = tabRow.scrollLeft + tabRow.clientWidth >= tabRow.scrollWidth - 1;
			this.tabsCard.classList.toggle("is-tab-row-end", atEnd);
		}
	}

	/**
	 * Stops navigation away from the page with unsaved changes, to ask first in the page's own modal.
	 * Switching tabs changes only the query and goes through.
	 * @return false to stop the navigation, nothing to let it through.
	 */
	onNavigation = (location: Location, action: Action): false | void => {
		if (location.pathname === this.props.location.pathname || this.props.isSubmitting || !this.getDirtyTabs().length) {
			return;
		}
		this.setState({pendingLeave: {location, action}});
		return false;
	}

	/**
	 * Carries on with the navigation the modal stopped, letting it through this time.
	 */
	leave = () => {
		const pending = this.state.pendingLeave;
		this.releaseNavigation();
		this.setState({pendingLeave: null});
		if (!pending) {
			return;
		}
		// The browser's back was undone when it was stopped, so it is made again.
		if (pending.action === "POP") {
			this.props.history.goBack();
		}
		else if (pending.action === "REPLACE") {
			this.props.history.replace(pending.location);
		}
		else {
			this.props.history.push(pending.location);
		}
	}

	releaseNavigation() {
		if (this.unblock) {
			this.unblock();
			this.unblock = null;
		}
	}

	/**
	 * Closing or reloading the browser tab is out of the page's reach: browsers allow only their own dialog there.
	 */
	warnBeforeUnload = (event: BeforeUnloadEvent) => {
		if (this.getDirtyTabs().length > 0) {
			event.preventDefault();
			event.returnValue = LEAVE_WITH_UNSAVED_CHANGES;
			return LEAVE_WITH_UNSAVED_CHANGES;
		}
		return undefined;
	}

	componentWillReceiveProps(newProps: Props) {
		const newState: any = {}
		if (this.state.bankDataForm.isEmpty || this.props.partnerBrand.id != newProps.partnerBrand.id) {
			newState["bankDataForm"] = newProps.bankData.map(bd => PartnerBrandBankDataForm.createFromPartnerBrandBankData(bd));
		}
		if (this.state.rewardsDataForm.isEmpty || this.props.partnerBrand.id != newProps.partnerBrand.id) {
			newState["rewardsDataForm"] =
				newProps.rewardsData.map(rd => PartnerBrandRewardsDataForm.createFromPartnerBrandRewardsData(rd))
		}
		if (newState.bankDataForm) {
			this.initialBankDataForm = newState.bankDataForm;
		}
		if (newState.rewardsDataForm) {
			this.initialRewardsDataForm = newState.rewardsDataForm;
		}
		if (this.initialCustomFieldsValues.isEmpty) {
			this.initialCustomFieldsValues = newProps.customFieldsValues.map(values => JSON.stringify(values));
		}
		if (Object.keys(newState).length) {
			this.setState(newState)
		}
	}

	render() {
		const partnerBrandId = option(this.props.partnerBrand.id);
		const sectionProps = {
			...this.props,
			form: this.state.form,
			onFieldChange: this.onFieldChanged,
			onFieldCompleted: this.onFieldCompleted,
			onFocusChange: this.onFocusChange,
			onFieldsChange: this.onFieldsChanged,
			onDealerPriceMatrixChange: this.onDealerPriceMatrixChange,
			onAddFile: this.onAddFile,
			onRemoveFile: this.onRemoveFile,
			partnerBrandId
		};
		const selectedTab = this.getSelectedTab();
		const errorTabs = this.state.shouldValidate ? this.getErrorTabs() : [];
		const dirtyTabs = this.getDirtyTabs();
		return (
			<>
				{this.state.pendingLeave &&
				<UnsavedChangesModal dirtyTabs={dirtyTabs}
									 onStay={() => this.setState({pendingLeave: null})}
									 onLeave={this.leave}/>}
				<div className={"c-pb-header"}>
					<Link to={Routes.PartnerBrandList}
						  className={"c-pb-header_back"}
						  aria-label={"Back to partner brands"}
						  title={"Back to partner brands"}>
						<IconWrapper icon={Icon.ArrowLeft} size={16} variant={"blue"}/>
					</Link>
					<h3 className={"c-pb-header_title"}>{this.props.partnerBrand.name}</h3>
					<div className={"c-pb-header_actions"}>
						<ButtonSecondary label={"Copy ID"} onClick={this.copyId}/>
						<PartnerBrandActionsMenu actions={this.getActions()}
												 legacyActions={this.getLegacyActions()}
												 hasUnsavedChanges={dirtyTabs.length > 0}/>
					</div>
				</div>
				{this.renderImportantNote()}
				<div className={"c-pb-tabs"} ref={el => this.tabsCard = el}>
					<TabSet>
						{PARTNER_BRAND_TABS.map(tab => {
							const errors = errorTabs.filter(t => t.tab === tab).map(t => t.count)[0] || 0;
							return <Tab key={tab}
										label={PARTNER_BRAND_TAB_LABELS[tab]}
										tabId={tab}
										selectedTabId={selectedTab}
										onClick={() => this.selectTab(tab)}>
								{/* Markers sit in the tab's padding, so a tab never gets wider when one appears. */}
								{errors > 0 ?
									<span className={"c-pb-tab-marker is-error"} aria-label={"fields with errors"}>{errors}</span>
									: dirtyTabs.indexOf(tab) >= 0 &&
									<span className={"c-pb-tab-marker c-pb-dirty-dot"} aria-label={"unsaved changes"}/>}
							</Tab>;
						})}
					</TabSet>
					<TabSetContent isWhite={true}>
						{/* All panels stay mounted and only the selected one shows, so switching tabs keeps what was typed. */}
						<div hidden={selectedTab !== PartnerBrandTab.Company} ref={el => this.panels[PartnerBrandTab.Company] = el}>
							<div className={"c-create-brand"}>
								<PartnerBrandCompanySection {...sectionProps}/>
							</div>
							{this.props.customFields.getOrElse([]).length > 0 && this.props.customFieldsValues.isDefined &&
							<PartnerBrandCustomFieldsValues customFields={this.props.customFields}
															customFieldsValues={this.props.customFieldsValues}
															updateCustomFieldsValues={this.props.updateCustomFieldsValues}/>}
						</div>
						<div hidden={selectedTab !== PartnerBrandTab.Payouts} ref={el => this.panels[PartnerBrandTab.Payouts] = el}>
							<div className={"c-create-brand"}>
								<PartnerBrandPayoutsSection {...sectionProps}/>
							</div>
						</div>
						<div hidden={selectedTab !== PartnerBrandTab.Features}>
							<PartnerBrandFeaturesSection partnerBrand={this.props.partnerBrand}
														 hasUnsavedChanges={dirtyTabs.length > 0}/>
						</div>
						<div hidden={selectedTab !== PartnerBrandTab.Users}>
							<div className={"c-pb-scroll"}>
								<PartnerBrandUsersTable partnerBrandId={this.props.partnerBrand.id}
														onRowClick={this.onUserRowClick}/>
							</div>
						</div>
						<div hidden={selectedTab !== PartnerBrandTab.Legacy} ref={el => this.panels[PartnerBrandTab.Legacy] = el}>
							<div className={"c-create-brand"}>
								<PartnerBrandLegacySection {...sectionProps}/>
							</div>
							{this.state.bankDataForm.map(bankForm =>
								<PartnerBrandBankDataFormBody form={bankForm}
															  onFieldsChange={this.onBankFieldsChanged}
															  onFieldChange={this.onBankFieldChanged}
															  {...this.props}/>
							).orNull}
							{this.state.rewardsDataForm.map(rewardsForm =>
								<PartnerBrandRewardsDataFormBody partnerBrandId={partnerBrandId}
																 form={rewardsForm}
																 onFieldChange={this.onRewardFieldChanged}
																 {...this.props}
																 totalUsedPoints={this.props.rewardsData.map(
																	 rd => rd.usedPoints).getOrElse(
																	 0)}
																 totalEarnedPoints={this.props.rewardsData.map(
																	 rd => rd.earnedPoints).getOrElse(0)}
																 totalAvailablePoints={this.props.rewardsData.map(
																	 rd => rd.availablePoints).getOrElse(0)}
																 totalSubmittedPoints={this.props.rewardsData.map(
																	 rd => rd.submittedPoints).getOrElse(0)}/>
							).orNull}
						</div>
					</TabSetContent>
				</div>
				<PartnerBrandSaveBar dirtyTabs={dirtyTabs}
									 errorTabs={errorTabs}
									 onErrorTabClick={this.revealFirstError}
									 onDiscard={this.props.onDiscard}
									 onSave={() => this.submitForm()}
									 isSubmitting={this.props.isSubmitting}
									 alignTo={() => this.tabsCard}/>
				{this.state.showJobTypeModal &&
				<PartnerBrandJobTypesConfigModal partnerBrandId={this.props.partnerBrand.id}
												 onFinish={() => this.setState({showJobTypeModal: false})}/>}
				{this.state.importCustomersAndLeadModalVisible &&
				<ImportPartnerBrandCustomersAndLeadsModal partnerBrandId={this.props.partnerBrand.id}
														  onClose={() => this.setState(
															  {importCustomersAndLeadModalVisible: false})}
				/>}
				{this.state.showVehiclesImportModal &&
				<UploadPartnerBrandVehiclesModal partnerBrandId={this.props.partnerBrand.id}
												 onClose={() => this.setState({showVehiclesImportModal: false})}/>}
				{this.state.showBoostersModal &&
				<PartnerBrandBoostersModal partnerBrandId={this.props.partnerBrand.id}
										   onFinish={() => this.setState({showBoostersModal: false})}/>}
				{this.state.showQuoteEmailTemplatesModal &&
				<EditQuoteEmailTemplatesModal partnerBrandId={this.props.partnerBrand.id}
											  onClose={() => this.setState({showQuoteEmailTemplatesModal: false})}/>}
			</>
		);
	}

	/**
	 * The saved Important note, shown above the tabs so that nobody misses it whichever tab they open.
	 */
	renderImportantNote() {
		const note = this.props.partnerBrand.noteImportant.map(n => n.trim()).filter(n => n.length > 0);
		return note.map(text =>
			<div className={"c-pb-important-note"} role={"note"}>
				<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a35f00" strokeWidth="2.5"
					 strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
					<path d="M12 9v4M12 17h.01M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>
				</svg>
				<span>{text}</span>
			</div>
		).orNull;
	}

	getActions(): PartnerBrandAction[] {
		return [
			{label: "Job types configuration", onSelect: () => this.setState({showJobTypeModal: true}), disabled: this.props.isSubmitting},
			{label: "Import vehicles", onSelect: () => this.setState({showVehiclesImportModal: true}), disabled: this.props.isSubmitting}
		];
	}

	getLegacyActions(): PartnerBrandAction[] {
		const actions: PartnerBrandAction[] = [
			{label: "Boosters", onSelect: () => this.setState({showBoostersModal: true}), disabled: this.props.isSubmitting}
		];
		if (this.quoteEmailTemplatesAvailable) {
			actions.push({label: "Quote e-mail templates", onSelect: () => this.setState({showQuoteEmailTemplatesModal: true})});
		}
		actions.push(
			{label: "Upload customers and leads", onSelect: () => this.setState({importCustomersAndLeadModalVisible: true}), disabled: this.props.isSubmitting},
			{label: "Send all documents", onSelect: this.onSendAllDocuments, disabled: this.state.isDownloadingDocuments}
		);
		return actions;
	}

	getSelectedTab(): PartnerBrandTab {
		const fromUrl = new URLSearchParams(this.props.location.search).get("tab");
		return PARTNER_BRAND_TABS.find(tab => tab === fromUrl) || PartnerBrandTab.Company;
	}

	/**
	 * The tab lives in the URL, so a link can open the page on it. Replacing the query keeps this
	 * component mounted, and with it the form.
	 */
	selectTab(tab: PartnerBrandTab) {
		const params = new URLSearchParams(this.props.location.search);
		params.set("tab", tab);
		this.props.history.replace({...this.props.location, search: `?${params.toString()}`});
	}

	copyId = () => {
		TextUtils.copyToClipboard(this.props.partnerBrand.id);
		Toast.success("Identifier has been copied to clipboard", "Copy ID");
	}

	/**
	 * On change reward related field value.
	 * @param field updated field.
	 */
	onRewardFieldChanged = (field: FormField<any>) => {
		this.state.rewardsDataForm.map(rewardsForm => {
			const newForm = rewardsForm.updateField(field);
			this.setState({rewardsDataForm: option(this.state.shouldValidate ? newForm.validate() : newForm)});
		})
	};

	/**
	 * On change bank data fields value.
	 * @param fields updated fields.
	 */
	onBankFieldsChanged = (fields: FormField<any>[]) => {
		this.state.bankDataForm.map(bankForm => {
			const newForm = bankForm.updateFields(fields);
			this.setState({bankDataForm: option(this.state.shouldValidate ? newForm.validate() : newForm)});
		})
	};

	/**
	 * On change bank data field value.
	 * @param field
	 */
	onBankFieldChanged = (field: FormField<any>) => {
		this.state.bankDataForm.map(bankForm => {
			const newForm = bankForm.updateField(field);
			this.setState({bankDataForm: option(this.state.shouldValidate ? newForm.validate() : newForm)});
		})
	};

	submitForm(): void {
		const validatedBankDataForm = this.state.bankDataForm.map(bankForm => bankForm.validate());
		const validatedRewardsDataForm = this.state.rewardsDataForm.map(rewardsForm => rewardsForm.validate());
		const validatedMainForm = this.state.form.validate();
		const address: Option<Address> = this.state.form.address.getOptionalValue();

		this.setState({
			bankDataForm: validatedBankDataForm,
			rewardsDataForm: validatedRewardsDataForm,
			form: validatedMainForm,
			shouldValidate: true
		}, () => {
			const errorTabs = this.getErrorTabs();
			if (errorTabs.length) {
				this.revealFirstError(errorTabs[0].tab);
				return;
			}
			const submit = (rewardsData: Option<PartnerBrandRewardsData>, bankData: Option<PartnerBrandBankData>) =>
				validatedMainForm.onValid(partnerBrand => this.props.onSubmit(partnerBrand, address, rewardsData, bankData));
			if (validatedBankDataForm.isDefined && validatedRewardsDataForm.isDefined) {
				validatedBankDataForm.get.onValid(bankData =>
					validatedRewardsDataForm.get.onValid(rewardsData => submit(option(rewardsData), option(bankData))));
			}
			else if (validatedBankDataForm.isDefined) {
				validatedBankDataForm.get.onValid(bankData => submit(none, option(bankData)));
			}
			else if (validatedRewardsDataForm.isDefined) {
				validatedRewardsDataForm.get.onValid(rewardsData => submit(option(rewardsData), none));
			}
			else {
				submit(none, none);
			}
		});
	}

	onUserRowClick = (user: User) => {
		window.open(Routes.OrganisationUserEdit(user.id), '_blank');
	}

	onSendAllDocuments = () => {
		this.setState({isDownloadingDocuments: true});
		api.instance.partnerBrandApi.sendAllDocuments(this.props.partnerBrand.id)
			.then(() => {
				this.setState({isDownloadingDocuments: false})
				Toast.success("Download link has been sent", "Download link send")
			})
			.catch((error) => {
				this.setState({isDownloadingDocuments: false})
				notifyBugsnagAndShowToast(error, "Download link send");
			})
	}
}

export default withRouter<IComponentProps>(UpdatePartnerBrandFormView);
